export default class QrCodeCriteria {
    constructor({
      name,
      qrCodeType
    } = {}) {
      this.name = name
      this.qrCodeType = qrCodeType
    }
  }